/* eslint-disable import/no-anonymous-default-export */
import { InfoCircleOutlined } from "@ant-design/icons";
import { Button, Input, Modal, Table, Tooltip } from "antd";
import { FilterValue } from "antd/lib/table/interface";
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { createGlobalStyle } from "styled-components";
import DataTable, { DataTableRef } from "../../common/components/DataTable";
import MainLayout from "../../common/components/MainLayout";
import useLoteConsultaAPI, { LoteConsulta } from "../../lotes-consulta/useLoteConsultaAPI";
import InfoColores from "../components/InfoColores";
import DataFilter from "../../common/components/DataFilter";
import CategoriasCodigoTags from "../../common/components/CategoriasCodigoTags";
import { Form } from "antd";

const GlobalStyle = createGlobalStyle`
  table
  {
    min-width:1400px!important;
  }
  .status-color
  {
    td:first-child
    {
        color:black;
    }
    td:not(.ant-table-cell-row-hover):last-child button
    {
        color:black;
    }
    td
    {
        color:black;
    }
    td.ant-table-cell-row-hover
    {
        color:black;
    }
    &.green {
        background:#43a047 ;
    }
    &.blue {
        background:#0288d1 ;
    }
    &.yellow {
        background:#efff41d3;
    }
    &.orange {
        background:#ee701b;
    }
    &.red {
        background:#ff5252;
    }
  }
`;

export default () => {
    const api = useLoteConsultaAPI();
    const navigate = useNavigate();
    const refTable = useRef<DataTableRef>(null!);
    const [modalInfoColoresVisible,setModalInfoColoresVisible] = useState<boolean>(false);
    const [ unidadProduccionForm ] = Form.useForm();
    
    const generateFilters = (filters: Record<string, FilterValue | null | any>) => {

        return [
            filters?.CantidadInfracciones == 0 ? `CantidadInfraccionesVerificadas add CantidadInfraccionesDescartadas eq CantidadInfracciones` : "",
            filters?.CantidadInfracciones == 1 ? `CantidadInfraccionesVerificadas add CantidadInfraccionesDescartadas eq 0` : "",
            filters?.CantidadInfracciones == 2 ? `CantidadInfraccionesVerificadas add CantidadInfraccionesDescartadas lt CantidadInfracciones` : "",
            filters?.CantidadInfracciones == 3 ? `CantidadInfraccionesConsultando gt 0` : "",
            filters?.UnidadProduccion != null ? `UnidadesProdNombre eq '${filters!.UnidadProduccion[0]}'` : "",
        ];

    }

    const handleChangeColorRow = (model: LoteConsulta) => {
        let color;
        const { CantidadInfraccionesVerificadas, CantidadInfraccionesDescartadas, CantidadInfracciones, CantidadInfraccionesConsultando , CantidadInfraccionesConsultadas } = model;
        let VerificadasyDescartadas = CantidadInfraccionesVerificadas + CantidadInfraccionesDescartadas;

        if (VerificadasyDescartadas === CantidadInfracciones) {
            color = "green";
        } if (CantidadInfraccionesConsultadas === CantidadInfracciones ) {
            color = "blue"
        }
        if (VerificadasyDescartadas < CantidadInfracciones && VerificadasyDescartadas > 0) {
            color = "yellow"
        }
        if (CantidadInfraccionesConsultando > 0) {
            color = "orange"
        }
        if (CantidadInfraccionesConsultando === CantidadInfracciones) {
            color = "red"
        }
        return color;
    }

    const onRowClassName = (model: LoteConsulta, rowNumber: number) => {
        return `status-color ${handleChangeColorRow(model)}`;
    };

    return (
        <MainLayout maxContentWidth={90}>
            <Modal
                onOk={() => setModalInfoColoresVisible(false)}
                okText={"Aceptar"}
                cancelButtonProps={{ style: { display: 'none' } }}
                width={"90%"}
                visible={modalInfoColoresVisible}
                onCancel={() => setModalInfoColoresVisible(false)}
            >
                <InfoColores />
            </Modal>
            <GlobalStyle />
            <Button onClick={() => setModalInfoColoresVisible(true)} type="default" icon={<InfoCircleOutlined />} size="small" style={{ color: "var(--primary-color)",marginBottom: '10px', paddingBottom: '5px' }}>
            ¿Qué significa cada color?
            </Button>
            <DataTable
                ref={refTable}
                list={(query) => api.list({ ...query, ...{ $expand: ["UltimoVerificador"],$filter:[...(query.$filter ?? []),...[`CantidadInfracciones gt 0`]] } })}
                delete={async (id) => {
                    const response = await api.delete(id);
                    await refTable.current.loadItems();
                    return response;
                }}
                defaultSortOrder={"NroLote desc"}
                itemActions={[
                    {
                        key: 'verificar',
                        label: 'Verificar',
                        action: (item) => navigate(`/verificacion/${item.NroLote}`)
                    }
                ]}
                title={"Lotes de verificación"}
                generateFilters={generateFilters}
                rowClassName={onRowClassName}
                defaultPageSize={10}
            >
                <Table.Column<LoteConsulta>
                    width={`10%`}
                    align="center"
                    title="Nro. de lote"
                    defaultSortOrder={'descend'}
                    dataIndex={"NroLote"}
                    sorter
                    sortDirections={["ascend", "descend", "ascend"]}
                />

                <Table.Column<LoteConsulta>
                    width={`8%`}
                    title="Inf."
                    dataIndex={"CantidadInfracciones"}
                    sorter
                    sortDirections={["ascend", "descend", "ascend"]}
                    filters={[
                        { text: "VERIFICADO", value: 0 },
                        { text: "VERIFICACION PENDIENTE", value: 1 },
                        { text: "VERIFICACION INICIADA", value: 2 },
                        { text: "CONSULTA PENDIENTE", value: 3 },

                    ]}

                />

                <Table.Column<LoteConsulta>
                    width={`8%`}
                    title="Verif."
                    dataIndex={"CantidadInfraccionesVerificadas"}
                    sorter
                    render={(value, record) => record.CantidadInfraccionesVerificadas}
                    sortDirections={["ascend", "descend", "ascend"]}

                />

                <Table.Column<LoteConsulta>
                    width={`8%`}
                    title="Desc."
                    dataIndex={"CantidadInfraccionesVerificadas"}
                    sorter
                    render={(value, record) => record.CantidadInfraccionesDescartadas}
                    sortDirections={["ascend", "descend", "ascend"]}

                />

                <Table.Column<LoteConsulta>
                    width={`8%`}
                    title="Pend."
                    dataIndex={"CantidadInfraccionesConsultadas"}
                    sorter
                    sortDirections={["ascend", "descend", "ascend"]}
                />

                <Table.Column<LoteConsulta>
                    width={`8%`}
                    title="Cons."
                    dataIndex={"CantidadInfraccionesConsultando"}
                    sorter
                    sortDirections={["ascend", "descend", "ascend"]}
                />

                <Table.Column<LoteConsulta>
                    width={`16%`}
                    title="Unidad de producción"
                    dataIndex = {"UnidadProduccion"}                    
                    render={(val, record) => (
                        <div style={{ textAlign: 'center' }}>
                            {record.UnidadesProdNombre
                            ? record.UnidadesProdNombre
                            : "-"}
                        </div>
                    )}
                    filterDropdown = {(props) => {
                        return (
                            <DataFilter filterDropdownProps = { props } form = { unidadProduccionForm }>                
                                <Form.Item name = {"UnidadProduccion"} style = {{ marginBottom: 10 }}>
                                  <Input placeholder = "Unidad de producción..."></Input>
                                </Form.Item>
                            </DataFilter>
                        );
                    }}
                />

                <Table.Column<LoteConsulta>
                    width={`14%`}
                    title="Categorías"
                    dataIndex={"CategoriasCodigo"}
                    render={(val, record) => <CategoriasCodigoTags categoriasCodigo={record.CategoriasCodigo} />}
                />

                <Table.Column<LoteConsulta>
                    width={`14%`}
                    title="Último verificador"
                    dataIndex={"UltimoVerificador"}
                    render={(value, record) => record.UltimoVerificador ? `${record.UltimoVerificador?.Nombre} ${record.UltimoVerificador?.Apellido}` : '-'}
                    sorter
                    sortDirections={["ascend", "descend", "ascend"]}
                />

            </DataTable>
        </MainLayout>
    );
}